package com.milta.feature.team.domain.entity

data class TeamMembership(
    val enterpriseId: String,
    val enterpriseName: String,
    val status: String, // "Active" | "Broken"
    val connectedAt: String,
)
